import * as React from 'react'
import AmountCellItem from './amount_cell_item'

type AmountCellItemProps = {
  id?: number
  locationId: number
  elementId: number
  campaignElementId: number
  amount: number
  minAmount: number
  maxAmount: number
  amountStep: number
  tagsAmount: number
}

export default function AmountCellItemApp(props: AmountCellItemProps) {
  return <AmountCellItem {...props} />
}
